/**
 * 后台错误 → 词条文案（`error.<CODE>`；时间参数按 UTC+9 显示并标注）。
 */
import { useI18n } from '@nexora/i18n/react';
import { errorText } from '@nexora/ui';
import { useCallback } from 'react';
import { useAdminTime } from '../format';

export function useAdminErrorText(): (error: unknown) => string {
  const { t } = useI18n();
  const time = useAdminTime();
  return useCallback((error: unknown) => errorText(error, { t, formatTime: (iso) => time(iso) }), [t, time]);
}
